import React from 'react';
import { Link } from 'react-router-dom';
import LabelViewHorizontal from './LabelViewHorizontal';
import LabelView from './LabelView';
import FIcon from './text/FIcon';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ItemCancelledFeedbackModal from '../pages/itens/ItemCancelledFeedbackModal';

export default class ListData extends React.Component {
  state = {};
  static propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.element)
  };

  static defaultProps = {
    atualizado_em: '',
    versao: '',
    buttons: []
  };

  renderDescription() {
    if (this.props.vertical) {
      return (
        <div className="row" style={{ display: 'flex' }}>
          {this.props.description
            ? this.props.description.map((data) => (
                <LabelView title={data.label} text={data.value} />
              ))
            : null}
        </div>
      );
    }
    return this.props.description
      ? this.props.description.map((data) => (
          <LabelViewHorizontal
            key={data.label}
            title={data.label}
            text={data.value}
          />
        ))
      : null;
  }

  renderTotvsInfos() {
    const { totvs } = this.props;
    if (totvs) {
      if (totvs.integracao_totvs) {
        const passedJson = JSON.parse(totvs.integracao_totvs);
        return (
          <div
            style={{
              display: 'grid',
              marginTop: '-0.4rem',
              marginBottom: '0.8rem',
              border: '1px solid ##bfbfbf',
              borderRadius: '4px',
              backgroundColor: '#FAFAFA',
              padding: '0.4rem'
            }}
          >
            <p
              style={{
                marginBottom: '-0.1rem',
                fontWeight: 600,
                fontSize: '14px'
              }}
              className="totvs-title"
            >
              IntegracaoTOTVS
            </p>
            <div className="label-horizontal mt-2">
              <li>
                <span>Curso:</span> {passedJson.curso}
              </li>
              <li>
                <span>ID Disciplina:</span> {passedJson.id_disciplina}
              </li>
              <li>
                <span>Disciplina:</span> {passedJson.disciplina}
              </li>
              <li>
                <span>Avaliação:</span> {passedJson.avaliacao}
              </li>
            </div>
          </div>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  toggleModal(name) {
    const { openModal } = this.state;
    this.setState({ openModal: openModal === name ? null : name });
  }

  render() {
    const { openModal } = this.state;
    const {
      title,
      small,
      atualizado_em,
      criado_em,
      versao,
      avaliacao,
      item_id,
      item
    } = this.props;
    return (
      <div className="list-data">
        <div className="list-data-title">
          <h3>{title}</h3>
          {small ? (
            <small className="list-data-text">
              <p>{small}</p>
            </small>
          ) : null}
          {this.renderDescription()}
          <div style={{ display: 'flex', fontSize: '12px' }}>
            {avaliacao && avaliacao.professor_responsavel ? (
              <>
                <span style={{ color: '#383838', fontWeight: '600' }}>
                  Professor Responsável:
                </span>

                {avaliacao.professor_responsavel.map((data) => (
                  <span
                    style={{
                      marginLeft: '0.5rem',
                      color: '#797979',
                      textTransform: 'uppercase'
                    }}
                  >
                    {data.last_name} -
                  </span>
                ))}
              </>
            ) : null}
          </div>
          {atualizado_em && versao && (
            <p className="meta-descip mt-2">
              <FIcon icon="clock" type="far" margin="5" />
              {criado_em && (
                <span className="mr-2 font-weight-normal">
                  Criado em: {criado_em} -
                </span>
              )}
              Última atualização: {atualizado_em} - <b>Versão {versao}</b>
              <Link to={`/itens/historico/${item_id}`} className="">
                Todas as versões
              </Link>
            </p>
          )}
          {get(item, 'status.id') === 10 && (
            <p className="meta-descip">
              <button
                type="button"
                onClick={() => this.toggleModal('verJustificativa')}
                className="btn btn-outline-info btn-sm"
              >
                <FIcon icon="eye" type="far" margin="5" />
                <span className="mr-2 font-weight-normal ">
                  Ver justificativa
                </span>
              </button>
            </p>
          )}
          {get(item, 'status.id') === 4 && (
            <p className="meta-descip">
              <button
                type="button"
                onClick={() => this.toggleModal('verJustificativaInativacao')}
                className="btn btn-outline-info btn-sm"
              >
                <FIcon icon="eye" type="far" margin="5" />
                <span className="mr-2 font-weight-normal ">
                  Ver justificativa
                </span>
              </button>
            </p>
          )}
          <ItemCancelledFeedbackModal
            isOpen={openModal === 'verJustificativa'}
            item_id={item_id}
            title={`Justificativa anulação - Item ${item_id}`}
            toggle={() => this.toggleModal('verJustificativa')}
            justification={get(item, 'justificativa_anulacao')}
          />
          <ItemCancelledFeedbackModal
            isOpen={openModal === 'verJustificativaInativacao'}
            title={`Justificativa inativação - Item ${item_id}`}
            toggle={() => this.toggleModal('verJustificativaInativacao')}
            justification={get(item, 'justificativa_inativacao')}
          />
          {this.renderTotvsInfos()}
          <div className="text-left">{this.props.buttons}</div>
        </div>
      </div>
    );
  }
}
